/**
 * Utilitaires pour la gestion des query parameters de l'API Bytel
 */

/**
 * Ajoute les query parameters à une URL
 * @param url - L'URL à modifier
 * @param params - Les paramètres à ajouter
 */
export const setQueryParams = (url: URL, params?: Record<string, unknown>): void => {
  if (!params) {
    return;
  }

  Object.entries(params).forEach(([key, value]) => {
    // Ignore les valeurs undefined, null et le token d'authentification
    if (value === undefined || value === null || key === 'idToken') {
      return;
    }

    // Convertit la valeur en string
    const stringValue = String(value);
    if (stringValue.length > 0) {
      url.searchParams.append(key, stringValue);
    }
  });
};

export default { setQueryParams };
